<template>
  <div class="qr-code-wrap">
    <div class="qr-code" v-if="signFinished">
      <h2 class="tips" v-if="loadingTicket">加载二维码中</h2>
      <VueQr
        v-else-if="ticketInfo"
        class="qr-code"
        :text="ticketInfo"
        :size="300"
        :margin="0"
        :correct-level="3"
        :logo-src="require('@/assets/logo.png')"
        :callback="setQrCode"
      ></VueQr>
    </div>
    <el-button v-if="signFinished" class="download" type="primary" @click.stop="saveQrImg"
      >下载签到二维码</el-button
    >
  </div>
</template>

<script>
import VueQr from "vue-qr";
import CurrentUserMixin from "@/mixin/CurrentUser";
import { SignInTicket } from "@/store/entity/signin";
import { FileUtils } from "@/store/entity/file";

export default {
  name: "SignInPage",
  components: {
    VueQr,
  },
  mixins: [CurrentUserMixin],
  data() {
    return {
      headerConfig: {
        headerIcon: "city ct-xiangyou",
        headerTitle: "现场签到",
      },
      dialogConfig: {
        title: "不能完成签到",
        width: "80%",
      },
      dialogShow: false,
      ticketInfo: null,
      loadingTicket: true,
      qrcodeUri: "",
    };
  },
  computed: {
    failReason() {
      if (this.currentSignup.status != "已完成") {
        return "会议报名信息未审核通过";
      } else if (
        ["A1", "A2", "A3", "A4", "A5"].includes(
          this.currentSignup.attendid.code
        ) &&
        this.currentSignup.paid_status != "已缴费"
      ) {
        if (
          this.currentSignup.paid_status === "已退费" ||
          this.currentSignup.paid_status === "申请退费"
        ) {
          return "已申请退费";
        } else {
          return "未完成缴费";
        }
      } else {
        // 需要用到failReason的情况是signFinished为false
        return "未知错误";
      }
    },
    signFinished() {
      // 是否完成了报名缴费
      if (this.currentSignup.id === 0) {
        // 还没初始化的情况
        return false;
      }

      if (this.currentSignup.status === "已完成") {
        if (["A6", "A7"].includes(this.currentSignup.attendid.code)) {
          // 无需报名的
          return true;
        } else if (
          ["A1", "A2", "A3", "A4", "A5"].includes(
            this.currentSignup.attendid.code
          ) &&
          this.currentSignup.paid_status == "已缴费"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  watch: {
    currentSignup: {
      handler(val) {
        if (this.signFinished) {
          this.getTicket();
          this.dialogShow = false;
        } else {
          this.ticketInfo = null;
          this.dialogShow = true;
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.currentSignup.id === 0) {
      // 还没初始化的情况
      return;
    }
    if (this.signFinished) {
      this.getTicket();
      this.dialogShow = false;
    } else {
      this.ticketInfo = null;
      this.dialogShow = true;
    }
  },
  methods: {
    async getTicket() {
      this.loadingTicket = true;
      const ticket = await SignInTicket.getSignInTicket(this.currentSignup.id);
      this.ticketInfo = JSON.stringify(ticket);
      this.loadingTicket = false;
    },
    handleClickIocn() {
      history.go(-1);
    },

    closeDialog(done) {
      done();
    },

    handleSure() {
      this.dialogShow = false;
    },

    setQrCode(uri, id) {
      this.qrcodeUri = uri;
    },
    saveQrImg() {
      if (!this.qrcodeUri) {
        return;
      }
      const file = FileUtils.dataURLtoFile(this.qrcodeUri, "签到二维码");
      const url = URL.createObjectURL(file);
      FileUtils.createDownloadAction(url, this.currentSignup.conference.title + "签到二维码.png", "application/png");
    },
  },
};
</script>

<style lang="scss" scoped>
.qr-code-wrap {
  text-align: center;

  .download {
    margin-top: 45px;
  }
}
//   .main {
//     width: 100%;
//     padding: 0 15px;
//     margin-bottom: 30px;
//     box-sizing: border-box;

//     .code-wrap {
//       margin-top: 30px;
//       padding: 15px;
//       border-radius: 5px;
//       box-sizing: border-box;

//       .tips {
//         color: var(--main-color);
//         margin-top: 15px;
//         font-size: 16px;
//         font-weight: bold;
//         text-align: center;
//       }

//       .qr-code {
//         width: 100%;
//         // height: 350px;
//         margin: 10px auto;
//         background: #666;
//       }
//     }

//     .save-code {
//       width: 100%;
//       margin-top: 50px;
//       background: var(--main-color);
//       color: #fff;
//       border: none;
//     }
//   }
//   ::v-deep .el-dialog {
//     background: var(--main-color);
//     border-radius: 5px;
//     .el-dialog__title,
//     .el-dialog__close {
//       color: #fff;
//     }

//     .reason {
//       text-align: center;

//       .sup {
//         font-size: 16px;
//         color: #fff;
//       }

//       .sure {
//         width: 100%;
//         background: #fff;
//         color: var(--main-color);
//         margin-top: 30px;
//         border: none;
//       }
//     }
//  }
</style>
